/* Interprets the same expression tree used by the app. No network calls. */
(()=>{
 if(window.skGeneratorEngineVersion===2)return;window.skGeneratorEngineVersion=2;
 const eligible=(m,input)=>m.product && (!input.cabin || m.cabin_qualified===true) && (!input.autostart || input.autostart==='any' || m.autostart==='confirmed' || (input.autostart==='accessory' && m.autostart==='accessory'));
 const evaluate=(node,vars)=>{
  if(typeof node==='number')return node;
  if(typeof node==='string'){if(!Number.isFinite(vars[node]))throw Error('Invalid rule variable');return vars[node];}
  const [op,...nodes]=node,a=nodes.map(n=>evaluate(n,vars));
  if(op==='max')return Math.max(...a);
  if(op==='*')return a[0]*a[1];
  if(op==='/')return a[0]/a[1];
  throw Error('Unknown calculation rule');
 };
 window.skGeneratorRecommend=(input)=>{
  const data=window.skGeneratorData;if(data?.schema!==1||!data.rules||!Array.isArray(data.models))throw Error('Missing catalog');
  const req={required_kw:0,required_kva:0};
  const scenarios=typeof input.scenarios==='string'?JSON.parse(input.scenarios):input.scenarios;
  for(const scenario of scenarios){
   const runningP=scenario.continuous/1000,runningS=runningP/input.pf,manualPeak=scenario.peak/1000/input.pf;
   const vars={runningP,runningS,peakP:Math.max(runningP,manualPeak*input.pf),peakS:Math.max(runningS,manualPeak),manualPeak,reserve:1+input.margin/100,target:Math.min(100,input.target_load+input.load_tolerance)/100,start_capacity:1,generator_pf:data.generator_pf};
   for(const [key,rule] of Object.entries(data.rules)){vars[key]=evaluate(rule,vars);if(!Number.isFinite(vars[key]))throw Error('Invalid calculation');req[key]=Math.max(req[key],vars[key]);}
  }
  const models=data.models.filter(m=>eligible(m,input)&&m.system===input.system&&m.fuel===input.fuel&&req.required_kw<=m.kw+1e-8&&req.required_kva<=m.kva+1e-8).sort((a,b)=>a.kva-b.kva);
  const m=models[0];return {version:data.version,requirements:req,status:!m?'no_match':!m.product?'needs_mapping':'matched',product:m?.product?{...m.product,kw:m.kw,kva:m.kva,verified:m.verified}:null};
 };
 window.skGeneratorOptions=(input)=>{
  const result=window.skGeneratorRecommend(input),r=result.requirements;
  const all=window.skGeneratorData.models.filter(m=>eligible(m,input)&&m.system===input.system&&m.fuel===input.fuel).sort((a,b)=>a.kva-b.kva);
  const fits=m=>r.required_kw<=m.kw+1e-8&&r.required_kva<=m.kva+1e-8;
  const recommended=all.find(fits);
  if(!recommended)return {...result,choices:[]};
  const smaller=all.filter(m=>m.kva<recommended.kva&&m.kw<=recommended.kw).at(-1);
  const larger=all.find(m=>m.kva>recommended.kva&&m.kw>=recommended.kw&&fits(m));
  return {...result,choices:[['smaller',smaller],['recommended',recommended],['larger',larger]].map(([role,model])=>({role,model:model||null,covers:model?fits(model):false}))};
 };
})();
